import React from 'react';
import { ChevronDown, Plus, Upload } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface AddMoreImagesDropdownProps {
  isOpen: boolean;
  onToggle: () => void;
  onAddFromDesktop: () => void;
  onAddFromCanva: () => void;
  isBusy: boolean;
  canvaLogo: string;
}

export const AddMoreImagesDropdown: React.FC<AddMoreImagesDropdownProps> = ({
  isOpen,
  onToggle,
  onAddFromDesktop,
  onAddFromCanva,
  isBusy,
  canvaLogo,
}) => {
  const { t } = useTranslation();
  return (
    <div className="relative">
      <button
        onClick={onToggle}
        className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-lg border border-primary-600 text-primary-700 bg-white hover:bg-primary-50"
      >
        <Plus className="w-4 h-4 mr-1.5" />
        {t('postContent.addMoreImages', 'Add more images')}
        <ChevronDown className={`w-4 h-4 ml-1.5 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-1 right-0 z-10 w-56 bg-white border border-gray-200 rounded-lg shadow-lg">
          <div className="py-1">
            <button
              onClick={onAddFromDesktop}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <Upload className="w-4 h-4 mr-3 text-green-500" />
              {t('actions.addFromDesktop', 'Add from desktop')}
            </button>
            <button
              onClick={onAddFromCanva}
              disabled={isBusy}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isBusy ? (
                <>
                  <div className="w-4 h-4 mr-3 border-2 border-t-transparent border-gray-500 rounded-full animate-spin"></div>
                  {t('common.loading', 'Loading...')}
                </>
              ) : (
                <>
                  <img src={canvaLogo} alt="Canva" className="w-4 h-4 mr-3" />
                  {t('actions.addFromCanva', 'Add from Canva')}
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};


